import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const BCBusinessSector = React.lazy(() =>
    import('../BCBusinessSector')
);
const bCBusinessSectorRoutesRegistry = [
    {
        path: PAGE_URL.B_C_BUSINESS_SECTOR_PAGE,
        element: <BCBusinessSector />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default bCBusinessSectorRoutesRegistry;
